// deps
import React from "react";

// internal-deps
import { CheckoutMetaInfoResponsePayload } from "@swiggy-private/native-bridge";
import { ApiResponse } from "@swiggy-private/payment-types";

// interfaces
import { GetPaymentMethodsResponse } from "@payment-client/interfaces/PaymentApi";

export interface ShowPaymentContextValue {
    loadingPayments: boolean;
    paymentResponse?: GetPaymentMethodsResponse | null;
    checkoutMetaInfo?: CheckoutMetaInfoResponsePayload | null;
    reloadPayments: () => void;
    refetchPayments: (splitpayMethods?: string, onRefetchErrCb?: Function) => void;
    isPaymentMethodSelectedForOnce?: boolean;
    setIsPaymentMethodSelectedForOnce: React.Dispatch<boolean>;
    _rawPaymentResponse?: GetPaymentMethodsResponse | null;
    paymentsError?: Error | ApiResponse;
}

export const ShowPaymentContext = React.createContext<ShowPaymentContextValue>({
    loadingPayments: false,
    reloadPayments: () => void 0,
    refetchPayments: () => void 0,
    setIsPaymentMethodSelectedForOnce: () => void 0,
});

if (__DEV__) {
    ShowPaymentContext.displayName = "ShowPaymentContext";
}
